export default () => ({
    list: [],
    currentSession: {},
    lessonTypes: {
        text: {
            enabled: true,
            type: 'basic',
            display: 'Text',
            value: 'text',
            icon: 'mdi-image-text',
            app: 'Text',
            editor: 'TextEditor',
            viewer: 'TextViewer',
        },
        pdf: {
            enabled: true,
            type: 'basic',
            display: 'PDF',
            value: 'pdf',
            icon: 'mdi-file-pdf-box',
            app: 'PDF',
            editor: 'PDFEditor',
            viewer: 'PDFViewer',
        },
        video: {
            enabled: false,
            type: 'basic',
            display: 'Video',
            value: 'video',
            icon: 'mdi-video',
            app: 'PDF',
            editor: 'PDFEditor',
            viewer: 'PDFViewer',
        },
        file: {
            enabled: true,
            type: 'basic',
            display: 'File',
            value: 'file',
            icon: 'mdi-download',
            app: 'PDF',
            editor: 'PDFEditor',
            viewer: 'PDFViewer',
        },
        quiz: {
            enabled: false,
            type: 'basic',
            display: 'Quiz',
            value: 'quiz',
            icon: 'mdi-help-circle-outline',
            app: 'PDF',
            editor: 'PDFEditor',
            viewer: 'PDFViewer',
        },
        tour: {
            enabled: true,
            type: 'advanced',
            display: 'Tour',
            value: 'tour',
            icon: 'mdi-screen-rotation',
            app: '360Tour',
            editor: '360TourEditor',
        },
        '3dQuiz': {
            enabled: true,
            type: 'advanced',
            display: '3D Quiz',
            value: '3dQuiz',
            icon: 'mdi-crosshairs-question',
            app: '360Quiz',
            editor: '360QuizEditor',
        },
        objective: {
            enabled: true,
            type: 'advanced',
            display: 'Practical',
            value: 'objective',
            icon: 'mdi-format-list-bulleted',
            app: '360Objective',
            editor: 'ObjectiveEditor',
        },
        // practical: {
        //     enabled: false,
        //     type: 'advanced',
        //     display: 'Practical',
        //     value: 'practical',
        //     icon: 'mdi-google-cardboard',
        //     app: '360Quiz',
        //     editor: '360TourEditor',
        //     viewer: 'PracticalViewer',
        // },
    },
});
